import React from 'react';

const BaseUrlContext = React.createContext('/');

export default BaseUrlContext;
